import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Automation } from "./automation";
import { Company } from "../../companies/_types/company";
import { Contract } from "../../companies/_types/contract";

export class AutomationCompany extends Resource {
    public override type = 'automationCompanies';


    @prop()
    public automationId!: string;
    public automation!: Automation;
    
    @prop()
    public companyId!: string;
    public company!: Company;
    
    @prop()
    public contractId?: string | null;
    public contract!: Contract;
}